"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getName = exports.getId = exports.getCoupon = void 0;
var _objects = require("../../utils/objects");
const getId = plan => (0, _objects.getObjectProperty)(plan, 'id');
exports.getId = getId;
const getName = plan => (0, _objects.getObjectProperty)(plan, 'nickname');
exports.getName = getName;
const getCoupon = plan => (0, _objects.getObjectProperty)(plan, 'coupon');
exports.getCoupon = getCoupon;